import { useState, useEffect } from 'react';
import categoryIcons from '../../../assets/categoryIcons.json';
import useDarkMode from '../../../hooks/useDarkMode';
import useThemeColor from '../../../hooks/useThemeColor';

const MediaLibrary = ({ onSelectImage, searchTerm = '' }) => {
  const [mediaFiles, setMediaFiles] = useState([]);

  const isDarkMode = useDarkMode();
  const themeColor = useThemeColor();

  useEffect(() => {
    if (categoryIcons && Array.isArray(categoryIcons)) {
      setMediaFiles(categoryIcons);
    } else {
      console.error('Failed to load category icons from JSON');
    }
  }, []);

  const filteredMediaFiles = mediaFiles.filter((file) =>
    file.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelect = (src) => {
    if (onSelectImage) {
      onSelectImage(src);
    }
  };

  return (
    <div className="container-fluid" style={{ padding: '16px 12px 8px' }}>
      <div className="row" style={{ maxHeight: '460px', overflowY: 'auto' }}>
        {filteredMediaFiles.length > 0 ? (
          filteredMediaFiles.map((file) => (
            <div key={file.id} className="col-md-2 col-sm-3 col-4 mb-3">
              <div
                className="card"
                style={{
                  cursor: 'pointer',
                  border: `1px solid ${isDarkMode ? '#4a5568' : '#D9D9D9'}`,
                  backgroundColor: isDarkMode ? '#2d3748' : '#ffffff',
                  transition: 'all 0.3s ease',
                  borderRadius: '12px',
                  overflow: 'hidden',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = themeColor;
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = `0 4px 12px ${themeColor}40`;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = isDarkMode ? '#4a5568' : '#D9D9D9';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
                onClick={() => handleSelect(file.src)}
              >
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    height: '96px',
                    padding: '8px',
                    position: 'relative',
                    backgroundColor: isDarkMode ? '#1a202c' : '#f8f9fa',
                  }}
                >
                  <img
                    src={file.src}
                    alt={file.name}
                    style={{
                      height: '64px',
                      width: '64px',
                      objectFit: 'contain',
                      filter: isDarkMode ? 'brightness(0.9)' : 'none',
                      display: 'block',
                    }}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      const parent = e.target.parentElement;
                      if (parent && !parent.querySelector('.fallback-icon')) {
                        const fallback = document.createElement('div');
                        fallback.className = 'fallback-icon';
                        fallback.innerHTML = `<i class="fa fa-image" style="font-size: 48px; color: ${isDarkMode ? '#4a5568' : '#ccc'};"></i>`;
                        fallback.style.cssText = 'display: flex; align-items: center; justify-content: center; width: 100%; height: 100%;';
                        parent.appendChild(fallback);
                      }
                    }}
                    onLoad={(e) => {
                      e.target.style.display = 'block';
                      const fallback = e.target.parentElement?.querySelector('.fallback-icon');
                      if (fallback) {
                        fallback.remove();
                      }
                    }}
                  />
                </div>
                <div className="card-body text-center" style={{ padding: '6px 8px' }}>
                  <h6
                    className="card-title mb-0"
                    style={{
                      fontSize: '12px',
                      color: isDarkMode ? '#e2e8f0' : '#212529',
                      fontWeight: '500',
                    }}
                  >
                    {file.name}
                  </h6>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-12 text-center py-5">
            <p style={{ color: isDarkMode ? '#a0aec0' : '#6c757d' }}>
              No icons found matching your search.
            </p>
          </div>
        )}
      </div>

      {filteredMediaFiles.length === 0 && mediaFiles.length === 0 && (
        <div className="text-center py-5">
          <p style={{ color: isDarkMode ? '#a0aec0' : '#6c757d' }}>No media files available.</p>
        </div>
      )}
    </div>
  );
};

export default MediaLibrary;
